export default {
  title: 'Zresetuj hasło',
  description: 'Wyślemy link do resetowania hasła na Twój adres e-mail.',
  sent: 'E-mail został wysłany.',

  form: {
    email: {
      title: 'E-mail',
      placeholder: 'Wprowadź e-mail',
    },
    button: {
      title: 'Zresetuj hasło',
    },
    error_messages: {
      error1: 'Brakujące informacje',
    },
  },
};
